'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './stations.routes';

export class StationsComponent {
  /*@ngInject*/
  constructor() {
    this.message = 'Hello';
  }
}

export default angular.module('appApp.stations', [uiRouter])
  .config(routes)
  .component('stations', {
    template: require('./stations.html'),
    controller: StationsComponent,
    controllerAs: 'stationsCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/stations/stations.component.js